import { IsOptional, IsString, MaxLength, IsInt, IsArray, MinLength } from 'class-validator';

export class CaseSearchDTO {

    @IsOptional()
    @IsString()
    @MaxLength(50)
    title: string;

    @IsOptional()
    @IsInt()
    source: number;

    @IsOptional()
    @IsInt()
    status: number;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    team: Array<string>;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    user: Array<string>;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    account: Array<string>;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    contact: Array<string>;

}
